import { useContent } from '@/hooks/useContent';

export default function AboutStory() {
  const { t } = useContent('about');
  const { t: imgT } = useContent('images');

  return (
    <section className="py-20 bg-background-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-16">
          <div className="w-full lg:w-[50%]">
            <span className="text-primary-500 text-xs font-semibold uppercase tracking-widest">{t('story_badge')}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3 leading-tight">
              {t('story_title')}
            </h2>
            <p className="text-foreground-400 mt-5 text-base leading-relaxed">
              {t('story_desc1')}
            </p>
            <p className="text-foreground-400 mt-4 text-base leading-relaxed">
              {t('story_desc2')}
            </p>
            <p className="text-foreground-50 font-semibold text-base mt-6 italic">{t('story_serving')}</p>
            <p className="text-primary-500 text-xs font-semibold uppercase tracking-widest mt-1">{t('story_tagline')}</p>
            <div className="flex items-start gap-8 mt-8">
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-extrabold text-primary-500">15+</p>
                <p className="text-primary-500 text-xs font-semibold uppercase tracking-wider mt-1">{t('story_years')}</p>
                <p className="text-primary-500 text-xs font-semibold uppercase tracking-wider">{t('story_experience')}</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-extrabold text-primary-500">100%</p>
                <p className="text-primary-500 text-xs font-semibold uppercase tracking-wider mt-1">{t('story_satisfaction')}</p>
                <p className="text-primary-500 text-xs font-semibold uppercase tracking-wider">{t('story_guaranteed')}</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-extrabold text-primary-500">{t('story_free')}</p>
                <p className="text-primary-500 text-xs font-semibold uppercase tracking-wider mt-1">{t('story_available')}</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[50%] flex justify-center">
            <div className="relative w-full max-w-[580px]">
              <img
                alt="FMO LLC insulation team working on residential project"
                className="w-full h-auto rounded-2xl"
                src={imgT('about_story')}
              />
              <div className="absolute bottom-4 left-4 bg-primary-500 text-white px-4 py-3 rounded-lg">
                <p className="text-[10px] font-semibold uppercase tracking-wider">Serving</p>
                <p className="text-lg font-extrabold">Lafayette</p>
                <p className="text-[10px] font-semibold uppercase tracking-wider">Indiana</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}